import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MenuProjectionData {
  params: any;
}

const initialState: MenuProjectionData = {
  params: null,
};

const ItemMenuProjectionSelectionDataSliceParams = createSlice({
  name: 'ItemMenuProjectionParams',
  initialState,
  reducers: {
    setMenuProjectionDataParams(state, action: PayloadAction<any>) {
      state.params = action.payload;
    },
  },
});

export const { setMenuProjectionDataParams } = ItemMenuProjectionSelectionDataSliceParams.actions;

export default ItemMenuProjectionSelectionDataSliceParams.reducer;